<template>
    <div class="exchange-offer-list">
        <div class="exchange-offer-list-currencies"  v-loading="pair_processing">
            <div class="trade-in-currencies" v-if="trade_in_asset_names && trade_in_asset_names.length>0">
                <h4>Trade In</h4>
                <el-menu
                    class="dashboard-menu"
                    text-color="#fff"
                    active-text-color="#fff"
                    @select="onTradeInCurrencyClick"
                    :default-active="selected_trade_in_asset_name"
                >
                    <el-menu-item v-for="trade_in_asset_name in trade_in_asset_names" :key="trade_in_asset_name" :index="trade_in_asset_name" >
                        <span slot="title">{{trade_in_asset_name}}</span>
                    </el-menu-item>
                </el-menu>
            </div>
            <div class="trade-out-currencies" v-if="selected_trade_in_asset_name&&trade_out_asset_names&&trade_out_asset_names.length>0">
                <h4>Trade Out</h4>
                <el-menu
                    class="dashboard-menu"
                    text-color="#fff"
                    active-text-color="#fff"
                    @select="onTradeOutCurrencyClick"
                    :default-active="selected_trade_out_asset_name"
                    
                >
                    <el-menu-item v-for="trade_out_asset_name in trade_out_asset_names" :key="trade_out_asset_name" :index="trade_out_asset_name" >
                        <span slot="title">{{trade_out_asset_name}}</span>
                    </el-menu-item>
                </el-menu>
            </div>
        </div>
        <div class="exchange-offer-list-content" v-loading="processing"> 
            <h3 v-if="isDealer">My Exchange Offers</h3>
            <div class="new-btn" @click="onNewClick" v-if="isDealer">
                <i class="el-icon-plus"></i> Create a new offer
            </div>
            
            <ExchangeOfferListItem v-for="item in tableData" :key="item.id" :data="item" :reload="reload" :onQuote="onQuote" :is_selected="selectedData"/>
            <div class="load-more" @click="loadMore" v-if="tableData.length<total">more...</div>
            <ExchangeOfferNew :show="showNew" :onClose="onNewClose" />
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapState } from "vuex";
import ExchangeOfferListItem from "@/components/ExchangeOfferListDynamicItem.vue";
import ExchangeOfferNew from "./ExchangeOfferNew";

export default {
    name: "ExchangeOfferListDynamic",
    components: {
        ExchangeOfferListItem,
        ExchangeOfferNew
    },
    data() {
        return {
            tableData: [],
            pairs: [],
            processing: false,
            pair_processing: false,
            showNew: false,
            selectedData: null,
            total: 0,
            skip: 0,
            selected_trade_in_asset_name: "",
            selected_trade_out_asset_name: "",
        };
    },
    mounted() {
        this.tableData = [];
        this.loadPairs();
        this.loadData();
        this.loadPermissions();
    },
    computed: {
        ...mapState({
            userInfo: state => state.userInfo,
            adminPerms: state => state.adminPerms,
        }),
        showDetail() {
            if (this.selectedData) {
                return true;
            }
            return false;
        },
        trade_in_asset_names() {
            let _trade_in_asset_names = [];
            for(let {trade_in_asset_name} of this.pairs) {
                if(_trade_in_asset_names.indexOf(trade_in_asset_name) < 0) {
                    _trade_in_asset_names.push(trade_in_asset_name);
                }
            }
            // if(_trade_in_asset_names.length > 0) {
            //     this.selected_trade_in_asset_name = _trade_in_asset_names[0];
            // }
            return _trade_in_asset_names;
        },
        trade_out_asset_names() {
            let _trade_out_asset_names = [];
            for(let {trade_in_asset_name, trade_out_asset_name} of this.pairs) {
                if(_trade_out_asset_names.indexOf(trade_out_asset_name) < 0 && (this.selected_trade_in_asset_name == trade_in_asset_name || this.selected_trade_in_asset_name == null) ) {
                    _trade_out_asset_names.push(trade_out_asset_name);
                }
            }
            // if(_trade_out_asset_names.length > 0) {
            //     this.selected_trade_out_asset_names = _trade_out_asset_names[0];
            // }
            return _trade_out_asset_names;
        },
        isDealer() {
            // return this.userInfo.perms.findIndex( p => { return p == 'DEALER'}) >= 0;
            if(this.userInfo && this.adminPerms && this.adminPerms.exchange.length >= 0 && this.adminPerms.exchange[0].visibility == 1) {
                return true;
            }
            return false;
        },
        isAdmin() {
            if(this.adminPerms && this.adminPerms.exchange && this.adminPerms.exchange[0].visibility) {
                return true;
            }
            return false;
        }
    },
    watch: {
        selected_trade_in_asset_name(newName, OldName) {
            if(newName != OldName) {
                this.tableData = [];
                this.loadData();
            }
        },
        selected_trade_out_asset_name(newName, OldName) {
            if(newName != OldName) {
                this.tableData = [];
                this.loadData();
            }
        },
    },
    methods: {
        ...mapActions(["request", "getError","setAdminPerms"]), 
        reload() {
            this.tableData = [];
            this.pairs = [];
            this.loadPairs();
            this.loadData();
        },
        loadPairs() {
            let ctrl = this;
            ctrl.pair_processing = true;
            let where = "type='DYNAMIC'  AND enabled=1";
            // if(trade_in_asset_name) {
            //     if(where.length > 0) {
            //         where += ` AND `;
            //     }
            //     where += `trade_out_asset_name='${trade_in_asset_name}'`
            // }
            
            // if(trade_out_asset_name) {
            //     if(where.length > 0) {
            //         where += ` AND `;
            //     }
            //     where += ` trade_out_asset_name='${trade_out_asset_name}' `;
            // }
            ctrl.request({
                method: "GET",
                endpoint: `exchange/pairs?where=${where}`
            })
                .then(({ data = {} }) => {
                    ctrl.pairs = data;
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    setTimeout(() => {
                        ctrl.pair_processing = false;
                    }, 500);
                });
        },
        
        loadData({ skip = 0, limit = 100, id = null } = {}) {
            let ctrl = this;
            ctrl.processing = true;
            let where = "type='DYNAMIC'  AND enabled=1";
            // if(!ctrl.isAdmin&&!ctrl.isDealer) {
            //     if(where.length > 0){
            //         where +=` AND `;
            //     }
            //     where += `enabled=1`;
            // }
            // if(ctrl.isDealer) {
            //     if(where.length > 0){
            //         where +=` AND `;
            //     }
            //     where += `authenticate_id=${ctrl.userInfo.authenticate_id}`;
            // }
            if(ctrl.selected_trade_in_asset_name && ctrl.selected_trade_in_asset_name.length > 0) {
                if(where.length > 0){
                    where +=` AND `;
                }
                where += ` trade_in_asset_name='${ctrl.selected_trade_in_asset_name}' `
            }
            if(ctrl.selected_trade_out_asset_name && ctrl.selected_trade_out_asset_name.length > 0) {
                if(where.length > 0){
                    where +=` AND `;
                }
                where += ` trade_out_asset_name='${ctrl.selected_trade_out_asset_name}' `
            }
            let endpoint = `exchange`;
            
            let params = {
                limit,
                skip
            }
            if(where.trim().length > 0) {
                params.where = `${where.trim()}`
            }
            ctrl.request({
                method: "GET",
                endpoint,
                params
            })
                .then(({ data = {} }) => {
                    if(skip == 0) {
                        ctrl.tableData = [];
                    }
                    ctrl.total = data.total;
                    ctrl.skip += data.results.length;
                    
                    if (id) {
                        for (let result of data.results) {
                            if (result.id == id) {
                                ctrl.selectedData = Number(id);
                            }
                        }
                    }
                    ctrl.tableData = [...ctrl.tableData, ...data.results];
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    setTimeout(() => {
                        ctrl.processing = false;
                    }, 500);
                });
        },
        loadMore() {
            this.loadData({ skip: this.skip });
        },
        onNewClose(reload = false, id = null) {
            this.showNew = false;
            if (reload == true) {
                this.tableData = [];
                this.loadData({ id });
            }
        },
        onDetailClick(row) {
            this.selectedData = row.id;
        },
        onDetailClose(reload = false) {
            this.selectedData = null;
            if (reload == true) {
                this.tableData = [];
                this.loadData();
            }
        },
        onQuote(id) {
            this.tableData = [];
            this.loadData({id});
        },
        onTradeInCurrencyClick(asset_name) {
            if(this.selected_trade_in_asset_name == asset_name) {
                this.selected_trade_in_asset_name = null;
            }
            else{
                this.selected_trade_in_asset_name = asset_name;
            }
        },
        onTradeOutCurrencyClick(asset_name) {
            if(this.selected_trade_out_asset_name == asset_name) {
                this.selected_trade_out_asset_name = null;
            }
            else{
                this.selected_trade_out_asset_name = asset_name;
            }
        },
        onNewClick() {
            this.showNew = true;
        },
        loadPermissions() {
            let ctrl = this;
            ctrl.processing = true;
            let endpoint = `my/permission`;
            ctrl.request({
                method: "GET",
                endpoint
            })
                .then(({ data = {} }) => {
                    ctrl.setAdminPerms(data);
                })
                .catch(err => {
                    ctrl.setAdminPerms();
                    ctrl.getError({
                        err
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    setTimeout(() => {
                        ctrl.processing = false;
                    }, 500);
                });
        },
    }
};
</script>
<style scoped>
.new-btn {
    width: 100%;
    line-height: 50px;
    cursor: pointer;
    color: #444;
    text-align: center;
    color: #fff;
    background-color:  #177CB0;
    border: 1px solid rgba(255, 255, 255, 0.5);
    margin-bottom: 4px;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.new-btn:hover {
    background-color: #00669a;
}

.new-btn:active {
    color: #fff;
    background-color: #177CB0;
}
.el-menu-item.is-active {
    background-color: rgba(0, 0, 0, 0.3);
}
.el-menu {
    height: 100%;
    background-color: #177CB0;
    border-right: solid 1px rgba(255, 255, 255, 0.15);
    width: 150px;
}
.el-menu-item:focus,
.el-menu-item:hover {
    outline: 0;
    background-color: rgba(0, 0, 0, 0.3);
}
.exchange-offer-list {
    display: flex;
    height: 100%;
    color: #fff;
}
.trade-in-currencies {
    background-color: rgba(0,0,0,0.3);
}
.trade-in-currencies h4 {
    text-align: center;
    background-color: #0e6d9e;
    border-bottom: 1px solid rgba(255,255,255,0.1);
    margin: 0;
    line-height: 50px;
    border-right: solid 1px rgba(255, 255, 255, 0.15);
}
.trade-out-currencies {
    background-color: rgba(0,0,0,0.3);
}
.trade-out-currencies h4 {
    text-align: center;
    background-color:#0e6d9e;
    border-bottom: 1px solid rgba(255,255,255,0.1);
    margin: 0;
    line-height: 50px;
}
.exchange-offer-list-currencies {
    display: flex;
    flex-direction: row;
}
.load-more {
    width: 100%;
    line-height: 50px;
    cursor: pointer;
    color: #fff;
    text-align: center;
    border: 1px solid #eee;
    margin-top: 16px;
}
.load-more:hover {
    color: #fff;
    background-color: #00669a;
}

.load-more:active {
    color: #fff;
    background-color: #177CB0;
}
.exchange-offer-list-content {
    width: 650px;
    box-sizing: border-box;
}
.exchange-offer-list-content h3 {
    padding: 0 16px;
    color: #333;
}
</style>

<style>
.trade-in-currencies .el-menu {
    height: calc(100% - 51px);
}
.trade-out-currencies .el-menu {
    height: calc(100% - 51px);
}
</style>